/**
 * Google AdSense Configuration
 * 
 * To use AdSense:
 * 1. Replace 'ca-pub-XXXXXXXXXXXXXXXX' in public/index.html with your actual AdSense publisher ID
 * 2. Replace 'ca-pub-XXXXXXXXXXXXXXXX' below with your actual AdSense publisher ID
 * 3. Or set REACT_APP_ADSENSE_PUBLISHER_ID environment variable
 * 
 * Your AdSense publisher ID can be found in your Google AdSense account.
 * It typically looks like: ca-pub-1234567890123456
 */

export const ADSENSE_PUBLISHER_ID = process.env.REACT_APP_ADSENSE_PUBLISHER_ID || 'ca-pub-8539529279649355';

/**
 * AdSense ad slot IDs
 * Create ad units in your AdSense account and replace these with your actual slot IDs
 */
export const ADSENSE_SLOTS = {
  // Example ad slot IDs - replace with your actual slot IDs from AdSense
  BANNER: '1234567890',
  SIDEBAR: '0987654321',
  IN_ARTICLE: '2537735282',
  AUTO_ADS: 'auto', // For auto ads
} as const;

/* 
<script async src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-8539529279649355"
     crossorigin="anonymous"></script>
<ins class="adsbygoogle"
     style="display:block"
     data-ad-format="fluid"
     data-ad-layout-key="-fb+5w+4e-db+86"
     data-ad-client="ca-pub-8539529279649355"
     data-ad-slot="2537735282"></ins>
<script>
     (adsbygoogle = window.adsbygoogle || []).push({});
</script>
*/